var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-0 text-help text-sm"},[_vm._v("El resultado estará disponible en la variable:"),_c('span',{staticClass:"text-primary ml-1"},[_vm._v(_vm._s(_vm.variableName))])])}
var staticRenderFns = []

export { render, staticRenderFns }